import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { MoreHorizontal } from "lucide-react";
import MarkFitModal from "../Introduction/MarkFitModal";
import ReportUserModal from "../MemberWantAd/ReportUserModal";
import { updateIntroduction } from "../../helpers/message";
import { updateIntroNotFit } from "../../services/introductionService";

const IntroRowActions = ({ intro, name, otherUserId }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [reasonOpen, setReasonOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const markNotFit = async (payload) => {
    if (!payload) return;
    const response = await updateIntroNotFit(payload).catch(() => null);
    if (response?.errorCode === 0) {
      await updateIntroduction(payload.IntroductionId, { isdeleted: true });
      setReasonOpen(false);
    }
  };

  return (
    <>
      <Dropdown className="inbox-row__menu" onClick={(event) => event.stopPropagation()}>
        <Dropdown.Toggle variant="" aria-label={`More for ${name}`}>
          <MoreHorizontal size={18} aria-hidden="true" />
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          <Dropdown.Item onClick={() => setConfirmOpen(true)}>Mark not interested</Dropdown.Item>
          <Dropdown.Item onClick={() => setReportOpen(true)}>Report user</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <MarkFitModal
        show={confirmOpen}
        onHide={() => setConfirmOpen(false)}
        titleText="Are you sure you want to mark this introduction as not fit?"
        description="This action will end the introduction and associated conversation. Once you delete this it cannot be undone."
        buttonTitle="Confirm & Delete"
        updateToNotFit={markNotFit}
        introductionId={intro.introductionId}
        showNotFirReasnPopup={reasonOpen}
        handleNotFitConfirm={() => {
          setConfirmOpen(false);
          setReasonOpen(true);
        }}
        markFitReasonModalClose={() => setReasonOpen(false)}
        name={name}
      />
      <ReportUserModal
        show={reportOpen}
        onHide={() => setReportOpen(false)}
        IntroductionId={intro.introductionId}
        inventoryDetails=""
        isFromMessage
        reportedUserId={otherUserId}
      />
    </>
  );
};

export default IntroRowActions;
